import $ from 'jQuery';

export default function() {
	'use strict';

	$('.card-person').on('click', '.see-story', function (evt) {
		evt.preventDefault();

		var $data_modal = $(this).attr("data-modal");

		if ($('.tab-content').hasClass('tab-content-active')) {

			$('.modal--modal.story-modal-' + $data_modal).show();
			$('html').addClass('modal-is-open');

			setTimeout(function () {
				$('.modal--modal.story-modal-' + $data_modal).addClass('active');
			}, 100);

			setTimeout(function () {
				$('.modal--modal--slidable').addClass('active');
			}, 200);

		}
	});

	$('.honoree-spotlight--top--links').on('click', '.see-story', function (evt) {
		evt.preventDefault();

		var $data_modal = $(this).attr("data-modal");

		$('.modal--modal.story-modal-' + $data_modal).show();
		$('html').addClass('modal-is-open');

		setTimeout(function () {
			$('.modal--modal.story-modal-' + $data_modal).addClass('active');
		}, 100);

		setTimeout(function () {
			$('.modal--modal--slidable').addClass('active');
		}, 200);
	});

	// close modal - reset to original markup
	$('html').on('click', '#honoreeModalClose', function (evt) {
		evt.preventDefault();

		var $data_modal = $(this).attr("data-modal");

		$('.modal--modal--slidable').removeClass('active');

		setTimeout(function () {
			$('.modal--modal.story-modal-' + $data_modal).removeClass('active');
		}, 100);

	});


	$('html').on('click', '#videoModalClose', function (evt) {
		evt.preventDefault();

		$('.honoree-spotlight--modal.video-modal').removeClass('active')

		setTimeout(function () {
			$('.honoree-spotlight--modal.video-modal').hide();
			$('html').removeClass('modal-is-open');
		}, 300);
	});
}
